import {
  createUserAsync,
  deleteUserAsync,
  getAllUserByLicenseAsync,
  getAllUsersByLicenseCountAsync,
  getUserByIdAsync,
  updateUserAsync,
} from '../../index';
import { useMutation } from 'react-query';

export const useCreateUserAsync = () => useMutation(createUserAsync);

export const useGetUserByIdAsync = () => useMutation(getUserByIdAsync);

export const useGetAllUserByLicenseAsync = () =>
  useMutation(getAllUserByLicenseAsync);

export const useGetAllUsersByLicenseCountAsync = () =>
  useMutation(getAllUsersByLicenseCountAsync);

export const useUpdateUserAsync = () => useMutation(updateUserAsync);

export const useDeleteUserAsync = () => useMutation(deleteUserAsync);
